/* eslint-disable no-nested-ternary */
/* eslint-disable arrow-parens */
/* eslint-disable comma-dangle */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';

import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-dracula';

import { Container } from './styles';
import api from '~/services/api';

export default function Feedback() {
  const [job, setJob] = useState('');
  const [status, setStatus] = useState('');
  const { id } = useParams();

  useEffect(() => {
    async function getData() {
      const { data } = await api.get(`applies/${id}`);

      setStatus(data);
      setJob(data.job);
    }

    getData();
  }, [id]);

  return (
    <>
      <p
        style={{
          fontSize: 26,
          paddingLeft: 40,
          color: '#36DED6',
          fontWeight: 'bold',
          paddingTop: 30,
        }}
      >
        Retorno da Vaga: {job.title} no {job.company}
      </p>
      {status.status === 'approved' ? (
        <Container>
          <h1>Parabéns, você foi aprovado para a fase de entrevista!</h1>
          <p>
            Clique no botāo abaixo para fazer o agendamento da nossa conversa.
          </p>
          <p style={{ fontSize: 16 }}>
            Faça o agendamento da entrevista o mais breve para nāo perder a
            chance de trabalhar nessa vaga.
          </p>
          <div className="link">
            <a
              href="https://calendly.com/apollo-partners/entrevista"
              target="_blank"
              rel="noopener noreferrer"
            >
              AGENDAR ENTREVISTA
            </a>
          </div>
          <Link to={`/jobs/${job.id}`}>
            <div className="job">
              <p>VER VAGA</p>
            </div>
          </Link>
        </Container>
      ) : status.status === 'processing' ? (
        <Container>
          <h1>Estamos analisando sua candidatura.</h1>
          <p>Em breve você receberá o nosso retorno.</p>

          <Link to={`/jobs/${job.id}`}>
            <div className="job">
              <p>VER VAGA</p>
            </div>
          </Link>
        </Container>
      ) : (
        <Container>
          <h1>
            Infelizmente, você foi nāo aprovado para a fase de entrevista!
          </h1>
          <p>
            Veja o nosso feedback, e o que você precisa atingir para trabalhar
            nessa vaga.
          </p>

          <div className="feedback">{status.feedback}</div>
          <Link to={`/jobs/${job.id}`}>
            <div className="job">
              <p>VER VAGA</p>
            </div>
          </Link>
        </Container>
      )}
    </>
  );
}
